'use client';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';

function ToggleScrollbarOnWTGamesAppInternal() {
  useEffect(() => {
    const className = 'hide-vertical-scrollbar';
    const el = document.documentElement;
    el.classList.add(className);

    return () => {
      el.classList.remove(className);
    };
  }, []);

  return null;
}

const ToggleScrollbarOnWTGamesApp = dynamic(
  () => Promise.resolve(ToggleScrollbarOnWTGamesAppInternal),
  { ssr: false },
);

export default ToggleScrollbarOnWTGamesApp;
